import React from "react";
import Details from "../Details/Details";

import "../../App.scss";

const Start_menu = () => {
  // const jsontype = process.env.REACT_APP_GAME_TYPE;
  // console.log("jsontype: ", process.env.REACT_APP_GAME_TYPE);

  // const mainTextContent1 = "Η θέσπιση του χριστιανισμού ως επίσημης θρησκείας από τον 4ο αιώνα και μετά οδήγησε στο χτίσιμο των πρώτων εκκλησιών, προκειμένου να στεγαστούν τα πολυάριθμα πλήθη των πιστών. Αρχιτεκτονικά ο πιο συνηθισμένος τύπος ναού ήταν η ξυλόστεγη βασιλική, δηλαδή ένα ορθογώνιο κτίριο με κιονοστοιχίες που το χωρίζουν σε κλίτη και με κόγχη στην ανατολική πλευρά. Χαρακτηριστικό παράδειγμα ξυλόστεγης βασιλικής με υπερώα στη Θεσσαλονίκη είναι η Αχειροποίητος που οικοδομήθηκε γύρω στα μέσα του 5ου αιώνα. Η αχειροποίητος, ήταν αφιερωμένη στην Παναγία και ήταν πλούσια διακοσμημένη με μαρμαροθετήματα, ψηφιδωτά, περίτεχνα κιονόκρανα και τοιχογραφίες. Αρχιτεκτονικά στοιχεία και αντικείμενα από βασιλικές της Μακεδονίας μπορείτε να δείτε στην Αίθουσα 1 του Μουσείου Βυζαντινού Πολιτισμού.";

  // const mainTextContent2 = "Στο παιχνίδι αυτό θα χτίσουμε μια Βασιλική από τα θεμέλια έως τη στέγη!";

  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;
  // console.log("process.env.REACT_APP_LANG_TYPE: ", gameLang);

  var mainTextContent1 = "";
  var mainTextContent2 = "";

  if (gameLang === "en") {
    mainTextContent1 = "The establishment of Christianity as the official religion from the 4th century, led to the building of the first churches, to house the numerous groups of the faithful. Architecturally, the most common type of church was the wooden-roofed basilica; a rectangular building with columns that separated it into a nave and an alcove in the eastern side. \n \n A characteristic example of a wooden-roofed basilica in Thessaloniki is Acheiropoietos, which was built somewhere in the middle of the 5th century. Acheiropoietos was dedicated to the Virgin and was richly decorated with marble inlay, mosaics, elaborate columns and frescoes. Architectural elements and objects from Macedonian basilicas can be seen in Gallery 1 of the Museum of Byzantine Culture.";
    mainTextContent2 = "In this game, we will build a basilica, from its foundations to its roof!";
  } else {
    mainTextContent1 = "Επιλέγοντας τη σωστή απάντηση σε κάθε βήμα θα ανακαλύπτεις σημαντικά στοιχεία σχετικά με το ανακτορικό συγκρότημα";
    mainTextContent2 = "Διάλεξε το επίπεδο δυσκολίας σύμφωνα με την τάξη σου";
  }

  return (
    <Details
      // logo={"logo"}
      // main_text = {mainTextContent1 + "\n \n" + mainTextContent2 + "\n \n"}
      main_text = {mainTextContent1}
      main_text2 = {mainTextContent2 + "\n \n"}
    />
  );
};

export default Start_menu;
